import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { API_URL, QueryParser } from "@frontend/basic";
import { catchError, Observable, of, switchMap, tap } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class ConnectionService 
{

    http = inject(HttpClient);
    apiUrl = inject(API_URL);

    public get<T extends {success: boolean}>(url: string): Observable<T|undefined>
    {
        return this.http.get<T>(url).pipe(
            tap((val) => {
                if (val === undefined || val.success === false) 
                {
                    this.sendErrorToLog(val).subscribe();
                } 
            }),
            catchError((err) => this.sendErrorToLog(err))
        );
    }

    public post<T extends {success: boolean}>(url: string, keys: any): Observable<T|undefined>
    {
        return this.http.post<T>(url, keys).pipe(
            tap((val) => {
                if (val === undefined || val.success === false) 
                {
                    this.sendErrorToLog(val).subscribe();
                } 
            }),
            catchError((err) => this.sendErrorToLog(err))
        );
    }

    public sendErrorToLog(err: any) 
    {
        return this.http.post(
            `${this.apiUrl}/v1/auth/logs`,
            {
                error: JSON.stringify(err),
                queryParams: JSON.stringify(window.location.href)
            }
        ).pipe(
            switchMap(() => of(undefined))
        );
    }

}